import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ArchivedFilterStatus } from 'models/order';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type ArchivedStatusDropdownProps = {
    archived: ArchivedFilterStatus;
    onArchivedStatusChange: (status: ArchivedFilterStatus) => void;
};

export const ArchivedStatusDropdown: FC<ArchivedStatusDropdownProps> = ({ archived, onArchivedStatusChange }) => {
    const { t: translate } = useTranslation(['orders', 'common']);
    return (
        <FormControl fullWidth>
            <InputLabel id="archive-status-select-label">{translate('orders:ARCHIVE_STATUS')}</InputLabel>
            <Select
                value={archived}
                onChange={(event: SelectChangeEvent) =>
                    onArchivedStatusChange(event.target.value as ArchivedFilterStatus)
                }
                labelId="archive-status-select-label"
                label={translate('orders:ARCHIVE_STATUS')}
            >
                {Object.values(ArchivedFilterStatus).map((archived, index) => {
                    return (
                        <MenuItem key={index} value={archived}>
                            {translate(archived)}
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    );
};
